import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { Btn, Input, Field } from "../kit";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";

export function DeleteOrderButton({ o }) {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [typed, setTyped] = useState("");
  const [busy, setBusy] = useState(false);
  const ok = typed.trim().toUpperCase() === o.order_no;
  const del = async () => {
    setBusy(true);
    try {
      await api.delete(`/orders/${o.id}`);
      toast.success(`Order ${o.order_no} dihapus`);
      nav("/order", { replace: true });
    } catch (x) { toast.error(errMsg(x)); setBusy(false); }
  };
  return (
    <>
      <Btn variant="danger" onClick={() => { setTyped(""); setOpen(true); }} data-testid="delete-order-btn"><Trash2 className="w-4 h-4" /> Hapus</Btn>
      <Dialog open={open} onOpenChange={(v) => !busy && setOpen(v)}>
        <DialogContent className="rounded-2xl" data-testid="delete-order-dialog">
          <DialogHeader>
            <DialogTitle>Hapus order {o.order_no}?</DialogTitle>
            <DialogDescription>Order, riwayat, dan file desainnya akan dihapus permanen. Riwayat mutasi stok tetap tersimpan. Ketik nomor order untuk konfirmasi.</DialogDescription>
          </DialogHeader>
          <Field label="Nomor order"><Input value={typed} onChange={(e) => setTyped(e.target.value)} placeholder={o.order_no} className="font-mono" data-testid="delete-order-confirm-input" /></Field>
          <Btn variant="danger" className="w-full" disabled={!ok} loading={busy} onClick={del} data-testid="delete-order-confirm-btn"><Trash2 className="w-5 h-5" /> Hapus Permanen</Btn>
        </DialogContent>
      </Dialog>
    </>
  );
}
